import { convertInchesToCm } from "~/utils";

export type MeasurementUnit = "in" | "cm";

export function useMeasurementUnit() {
  const unitCookie = useCookie<MeasurementUnit>("qam_measurement_unit", {
    default: () => "in",
    maxAge: 60 * 60 * 24 * 365,
    sameSite: "lax",
  });

  const globalUnit = useState<MeasurementUnit>("globalMeasurementUnit", () => unitCookie.value || "in");

  const setGlobalUnit = (unit: MeasurementUnit) => {
    globalUnit.value = unit;
    unitCookie.value = unit;
  };

  const formatDimensions = (sizeStr: string | null | undefined, unit?: MeasurementUnit): string => {
    if (!sizeStr) return "";
    const activeUnit = unit ?? globalUnit.value;
    if (activeUnit === "in") {
      if (!/in(ches)?|cm/i.test(sizeStr)) {
        return `${sizeStr} in`;
      }
      return sizeStr;
    }
    return convertInchesToCm(sizeStr);
  };

  return {
    globalUnit,
    setGlobalUnit,
    formatDimensions,
  };
}
